<div id="{{ id }}" mat-dialog-content>
  <ng-container *ngIf="!alertCom || alertCom === null">
    <button type="button" class="close" (click)="close()">
      <i class="fa-solid fa-xmark"></i>
    </button>

    <div *ngIf="title" style="text-align: center">
      <span class="title-modal" translate>
        <i class="far fa-heart" *ngIf="favoriteTab && !needValidateMsg"></i>
        {{ title }}
      </span>
    </div>
    <div class="mt-2" *ngIf="needValidateMsg">
      <div class="container-need-validate-email">
        <span class="d-flex">
          <mat-icon>mark_email_read</mat-icon>
        </span>
        <p translate>{{ needValidateMsg }}</p>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="data?.alert">
    <div class="done-container">
      <img src="../../../../assets/icons/illu-ok.svg" alt="ilustración ok" />
      <h3 translate>components.modalSuccesfull.done</h3>
      <p translate>components.modalSuccesfull.weWillSendEmail</p>
      <button class="yellow-btn" (click)="close()" translate>
        components.modalSuccesfull.close
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="alertCom">
    <button type="button" class="close" (click)="close()">
      <i class="fa-solid fa-xmark"></i>
    </button>
    <div class="mt-2">
      <span class="subtitle-modal" translate>
        {{ data?.message }}
      </span>
    </div>

    <div class="mt-2" *ngIf="needValidateMsg">
      <div class="container-need-validate-email">
        <span>
          <mat-icon>mark_email_read</mat-icon>
        </span>
        <p translate>{{ needValidateMsg }}</p>
      </div>
    </div>
  </ng-container>
</div>
